import {MI} from "../init";
import {AbstractSymbol} from "../symbol/AbstractSymbol";
import {madnes_start_freespins} from "../../framework/src/engine/madnes/madnes";
import {FsAnims} from "./FsAnims";
import {Arrow} from "../symbol/Arrow";
import {getRandomInt} from "../../framework/src/helpers";

/**
 * @constructor
 * @param {Game} game
 * @param {ResultController} resultController
 * @param {ServerResult} serverResult
 * @param {SymbolsManager} symbolsManager
 * @returns {WinControl}
 */

export function WinControl(game, resultController, serverResult, symbolsManager) {

    /** @type {Game}  */
    this._game = game;

    /** @type {GameAssets} */
    this._assets = game.assets;

    /** @type {Object<string,MadnesAudio>} */
    this._sounds = game.sounds;

    /** @type {ResultController} */
    this._resultController = resultController;

    /** @type {SpinReels} */
    this._reels = game.spinReels;

    /** @type {Function|null} */
    this._resolver;

    /** @type {ServerResultWinline} */
    this._winline;

    /** @type {SymbolsManager} */
    this._symbolsManager = symbolsManager;

    /** @type {Array<AbstractSymbol>} */
    //this._animsSymbols = [];

    /** @type {boolean} */
    this.runned = false;

    //this.resolve = function() {};

    /** @type {ServerResultWinline|undefined} */
    this.nextWinLine;

    /** @type {ServerResult} */
    this._serverResult = serverResult;

//	this._preloadWild = null;

    /** @type {MadnesObject} */
    this._winText;

    /** @type {MadnesObject} */
    this._winTextBg;
}

WinControl.prototype.init = function() {
    return new Promise(function(res) {
        this._resolver = res;
    }.bind(this));
};

/**
 * @param {number} symbolNum
 * @param {number} multi
 * @returns {undefined}
 */
WinControl.prototype._playWinlineSound = function(symbolNum, multi) {

    var name = "";

    switch(AbstractSymbol.getSymbolByNum(symbolNum)) {
        case "symbol_J":
        case "symbol_Q":
        case "symbol_K":
        case "symbol_A":
            name = "Letter";
            break;
        case "symbol_Bracelet": name = "Bracelet"; break;
        case "symbol_Shield": name = "Shield"; break;
        case "symbol_Axe": name = "Axe"; break;
        case "symbol_Helmet": name = "Helmet"; break;
        case "symbol_Woman": name = "Woman"; break;
        case "symbol_Viking": name = "Viking"; break;
        case "symbol_Wild": name = "Wild"; break;
        case "symbol_Scatter": name = "Ship"; break;
    }

    name = "win_" + (multi > 1 ? "Multiplier_" : "") + name;
    this._sounds[name].play();
};

/**
 * @param {ServerResultWinline|undefined} winline
 */
WinControl.prototype.setNextWinLine = function(winline) {
    this.nextWinLine = winline;
};

/** @returns {boolean} */
WinControl.prototype.isLastWinLine = function() {
    return !this.nextWinLine;
};

/** @returns {boolean} */
WinControl.prototype.isNextWinLine = function() {
    return !!this.nextWinLine;
};

/**
 * @param {string} type
 * @returns {boolean}
 */
WinControl.prototype.isNextWinType = function(type) {

    if(this.nextWinLine) {
        return this.nextWinLine.getType() === type;
    }

    return false;
};

/**
 *
 * @returns {number}
 */
WinControl.prototype._incControlResultPos = function() {
    //console.log('inc', this._resultController._controlResultPos + 1);
    return this._resultController.incControlResultPos();
};

/**
 * @param {boolean=} fromSkip
 * @returns {Promise}
 */
WinControl.prototype._onWinlineEnd = function(fromSkip) {
    var _self = this;

    return new Promise(function(res) {

        if(_self.nextWinLine) {
            res();
            return;
        }

        if(fromSkip && !_self._resultController.isBigWin()) {

            _self._reels.fadeOutBlackScreen();
            _self._showLogo(100).then(res);

        } else {

            var logo = _self._showLogo(100);
            var blackScreen = _self._reels.fadeOutBlackScreen();

            return Promise.all([logo, blackScreen]).then(res);
        }
    });
};

/**
 * @param {number=} duration
 * @returns {Promise}
 */
WinControl.prototype._showLogo = function(duration) {

    if(typeof duration === 'undefined') { duration = 200; }

    if(this._game.isInFreeSpins()) {
        return this._game.header.showFS(duration);
    } else {

        return this._game.header.showLogo(duration);
    }
};

WinControl.prototype.addWin = function() {
    if(this._winline.getWin()) {
        this._game.addWin(this._winline.getWin() * 1);
        //this.resultWin += this._winline.getWin() * 1;

        //this._game.gameRoundWin += this._winline.getWin();
        //this._game.gameTotalCredit += this._game.gameRoundWin;
    }
};

/**
 *
 * @param {number} duration
 * @param {number} perc
 */
WinControl.prototype._fadeBgMusic = function(duration, perc) {

    if(!this._game.isInFreeSpins()) {
        this._sounds["bg_Music"].fadeToPerc(duration, perc);
    } else {
        this._sounds["bg_FreeSpins_Loop"].fadeToPerc(duration, perc);
    }
};

/**
 * @param {ServerResultWinline} winline
 */
WinControl.prototype.run = function(winline) {

    var _self = this;

    this._runned = true;

    if(!this._resolver) throw new Error("resolver not set!! call init() first");

    this._winline = winline;

    /*if(this._game.isInFreeSpins()) { //skip animations
        this.addWin();
        this._resolver();
        return;
    }*/

    var winType = this._winline.getType();

    // MI.controls.winAnimAdd();

    new Promise(function(res) {

        if(winType === "normal" || winType === "wild") {
            return _self._resultController.playStorm().then(res);
        }

        res();

    }).then(function() {

        if((winType === "normal" || winType === "wild") && _self._isSkip()) {
            winType = "_skip";
        }

        _self._runWinType(winType);
    });
};

/**
 * @param {string=} winType
 */
WinControl.prototype._runWinType = function(winType) {

    switch(winType) {

        case "normal":

            this._animNormal();
            break;

        case "wild":

            this._animWild();
            break;

        case "showSymbols":

            this._animShowSymbols();
            break;

        case "freeSpins":

            this._animFreeSpins();
            break;

        case "_skip":

            this._animSkip();
            break;

        default:
            console.warn("winline type not defined");
//			this._resolver();
            break;
    }
};

/**
 * @returns {boolean}
 */
WinControl.prototype._isSkip = function() {
    return MI.controls.winAnimSkipClicked();
};

WinControl.prototype._animSkip = function() {

    var _self = this;

    var resSymbols = this._getResSymbols(this._winline.getPosition());
    var animsSymbols = this._symbolsManager.createAnimsSymbols(resSymbols, null, true);

    for(var i = 0; i < animsSymbols.length; i++) {

        this._reels.animsSymbolsGroup.add(animsSymbols[i]);

        animsSymbols[i].createSymbol();
//		animsSymbols[i].setAlpha(0);
        resSymbols[i].setVisible(true);
        resSymbols[i].locked = false;
    }


//	this._fadeOutStickSymbols().then().then(function() {
    _self._removeStickSymbols();
    _self._reels.visibleResSymbols(true);
//	});

    Promise.all([
        _self._reels.fadeInBlackScreen(), _self._game.header.showLines(100)
    ]).then(function() {

        _self._game.header.drawLine(_self._winline.getLine());

        _self.addWin();

        var won = _self._winline.getWin();

        _self._assets.getWinViewer().setWin(MI.moneyToCoin(won));
        return _self._assets.getWinViewer().animWinSkip(function()
        {
            _self._sounds["misc_Coin_Drop_" + getRandomInt(1, 5)].play();
        })
            .then(function()
            {
                return _self._assets.getWinViewer().animWinSkipHide((_self.isNextWinType("normal") || _self.isNextWinType("wild")));
            })
            .then(function() {

                for(var i = 0; i < animsSymbols.length; i++) {
                    animsSymbols[i].destroy();
                }
            });

    }).then(function() {
        return _self._onWinlineEnd(true);
    }).then(function() {
        _self._resolver();
    });
};

/**
 * @returns {undefined}
 */
WinControl.prototype._animNormal = function() {

    var _self = this;
    var won = this._winline.getWin();
    var multip = _self._winline.getMultiplier();

    this._fadeBgMusic(1000, 0.5);

    var resSymbols = this._getResSymbols(this._winline.getPosition());
    var animsSymbols = this._symbolsManager.createAnimsSymbols(resSymbols, this._winline.getSymbol());

    for(var i = 0; i < animsSymbols.length; i++) {
        this._reels.animsSymbolsGroup.add(animsSymbols[i]);
        //this._reels.animsSymbolsGroup.add(resSymbols[i]);

        animsSymbols[i].createWinSymbol();
        animsSymbols[i].setVisible(true);
        resSymbols[i].setVisible(false);
        resSymbols[i].locked = false;
    }

//	this._fadeOutStickSymbols().then(function() {
    _self._removeStickSymbols();
    _self._reels.visibleResSymbols(true);
//	});

    _self._reels.fadeInBlackScreen();

    _self._game.header.showLines(100).then(function() {
        _self._game.header.drawLine(_self._winline.getLine());
    });

    _self._playWinlineSound(_self._winline.getSymbol(), _self._winline.getMultiplier());

    this._assets.getWinViewer().setWin(MI.moneyToCoin(won));
    var winViewerAnim = this._assets.getWinViewer().animWin().then(function() {

        _self.addWin();

        return _self._assets.getWinViewer().animWinHide(_self._isSkip() && _self.isNextWinLine() && (_self.isNextWinType("normal") || _self.isNextWinType("wild")));
    });

    var winlineAnim = _self._playWinlineAnim(animsSymbols, multip).then(function() {

        for(var i = 0; i < animsSymbols.length; i++) {

            animsSymbols[i].destroyWin();
            animsSymbols[i].destroy();
            resSymbols[i].setVisible(true);
        }

        return _self._onWinlineEnd();
    });

    Promise.all([winViewerAnim, winlineAnim]).then(function() {
        _self._resolver();
    });
};

WinControl.prototype._animWild = function() {

    this._fadeBgMusic(1000, 0.5);

    var _self = this;
    var won = this._winline.getWin();

    var multip = this._winline.getMultiplier();

    var resSymbols = this._getResSymbols(this._winline.getPosition());
    var animsSymbols = this._symbolsManager.createAnimsSymbols(resSymbols);

    for(var i = 0; i < animsSymbols.length; i++) {
        this._reels.animsSymbolsGroup.add(animsSymbols[i]);

        animsSymbols[i].createWinSymbol(true);
        animsSymbols[i].createMulti(multip);
        animsSymbols[i].setVisible(true);
        resSymbols[i].setVisible(false);

        resSymbols[i].locked = false;
    }

//	this._fadeOutStickSymbols().then(function() {
    _self._removeStickSymbols();
    _self._reels.visibleResSymbols(true);
//	});

//	setTimeout(function() {
//		_self._preloadWild = MI.addImg(0, 0, "symbol_Wild_atlas");
//	}, 250);

    _self._reels.fadeInBlackScreen();

    _self._game.header.showLines(100).then(function() {
        _self._game.header.drawLine(_self._winline.getLine());
    });

    _self._playWinlineSound(_self._winline.getSymbol(), multip);

    this._assets.getWinViewer().setWin(MI.moneyToCoin(won));
    var winViewerAnim = this._assets.getWinViewer().animWin().then(function() {
        _self.addWin();
        return _self._assets.getWinViewer().animWinHide(_self._isSkip() && _self.isNextWinLine() && (_self.isNextWinType("normal") || _self.isNextWinType("wild")));
    });

    var winlineAnim = _self._playWinlineAnim(animsSymbols, multip).then(function() {

        for(var i = 0; i < animsSymbols.length; i++) {

            animsSymbols[i].destroyWin();
            animsSymbols[i].destroyMulti();
            animsSymbols[i].destroy();
            resSymbols[i].setVisible(true);
        }

        return _self._onWinlineEnd();
    });

    Promise.all([winViewerAnim, winlineAnim]).then(function() {
//		_self._preloadWild && _self._preloadWild.destroy();
//		_self._preloadWild = null;
        _self._resolver();
    });
};

WinControl.prototype._animShowSymbols = function() {
    var _self = this;

    var positions = this._winline.getPosition();
    var resSymbols = this._getResSymbols(positions);
    var stickSymbols = this._symbolsManager.createStickySymbols(resSymbols);

    var proms = [];

    var audioDucking = false;

//	for(var i = 0; i < resSymbols.length; i++) {
//		//resSymbols[i].locked = true;
//	}

    for(var i = 0; i < positions.length; i++) {

        var reelX = positions[i][0];

        this._reels.stickSymbols.push(stickSymbols[i]);
        this._reels.animsSymbolsGroup.add(stickSymbols[i]);

        var arrow = new Arrow();
        arrow.create(reelX, this._reels.arrowsSymbolsGroup);

        arrow.setSymbolDistance(stickSymbols[i]);
        arrow.setToSymbol(stickSymbols[i]);

        arrow.setOnStart(function() {
            _self._sounds["bonus_Arrow_" + getRandomInt(1, 2)].play();
        });

        stickSymbols[i].setArrow(arrow);

        (function(i) {
            arrow.setOnHit(function() {
                if(!audioDucking) {
                    _self._fadeBgMusic(100, 0.5);
                    audioDucking = true;
                }

                _self._sounds["bonus_Lock_Fire"].play();

                resSymbols[i].setVisible(false);
                stickSymbols[i].burn();
            });
        } (i));

        var p = arrow.play();
        proms.push(p);
    }

    Promise.all(proms).then(function() {
        _self._fadeBgMusic(500, 1);

        _self.addWin();

        if(_self._canRespin()) {
            _self._game.increaseRespins();
            _self._game.isRespin = true;
            return _self._game.respinStart();
        }

//		_self._game.increaseRespins();
//		if(!_self._game.isLastRespin()) {
//			_self._game.isRespin = true;
//
//			return _self._game.respinStart();
//		}

    }).then(function() {

        _self._game.isRespin = false;

        MI.createTimer().add(function() {
            _self._resolver();
        }, 500);
    });
};

WinControl.prototype._canRespin = function() {
    return this._game.isNextRespin();
};

//WinControl.prototype._isNextShowSymbols = function() {
//
//	if(!this.nextWinLine)
//	{
//		return false;
//	}
//
//	return true; //this.nextWinLine.getType() === "showSymbols";
//};

/**
 * @returns {undefined}
 */
WinControl.prototype._animFreeSpins = function() {

    madnes_start_freespins();

    var _self = this;
    var game = _self._game;

    this._resultController.setDisableFsEnd(true);

    var fsAnims = new FsAnims();
    fsAnims.setFsFiresComplete(function() {
        game.assets.showFireRopes();
    });

    // MI.controls.hideAllBtns();

    this._fadeBgMusic(1000, 0.5);

    var resSymbols = this._getResSymbols(this._winline.getPosition());
    var animsSymbols = this._symbolsManager.createAnimsSymbols(resSymbols, this._winline.getSymbol());

    for(var i = 0; i < animsSymbols.length; i++) {

        this._reels.animsSymbolsGroup.add(animsSymbols[i]);
        //this._reels.animsSymbolsGroup.add(resSymbols[i]);

        animsSymbols[i].createWinSymbol();
        animsSymbols[i].setVisible(true);
        resSymbols[i].setVisible(false);
    }

    this._reels.fadeInBlackScreen();

    _self._playWinlineSound(_self._winline.getSymbol(), 0);
    _self._playWinlineAnim(animsSymbols, 0).then(function() {

        _self.addWin();

        _self._sounds["bonus_FreeSpins_In"].play();

        for(var i = 0; i < animsSymbols.length; i++) {
            animsSymbols[i].destroy();
            resSymbols[i].setVisible(true);
        }

        _self._sounds["bg_Music"].fadeOut(200, false);

        fsAnims.create(game.assets.getFsGroup());
        fsAnims.createLabel();

        _self._reels.fadeOutBlackScreen();

        _self._sounds["bg_FreeSpins_Start"].play();
        MI.createTimer().add(function() {
            _self._sounds["bg_FreeSpins_Loop"].loop();
        }, 5400);

        _self._game.enterFreeSpins();

        return fsAnims.play();

    }).then(function() {

        return _self._game.countFreeSpins();

    }).then(function() {

        fsAnims.destroy();
        _self._resolver();
    });
};

/**
 * @param {Array<AbstractSymbol>} symbols
 * @returns {Array<AbstractSymbol>}
 */
WinControl.prototype._getWildSymbols = function(symbols) {
    var wilds = [];
    for(var i = 0; i < symbols.length; i++) {

        var reelX = symbols[i].getReelX();
        if(this._reels.getReel(reelX).spreaded) {
            wilds.push(symbols[i]);
        }
    }
    return wilds;
};

WinControl.prototype._fadeOutStickSymbols = function() {

    var _self = this;

    return new Promise(function(res) {
        for(var i = 0; i < _self._reels.stickSymbols.length; i++) {
            MI.addTween().to(_self._reels.stickSymbols[i], { 'alpha': 1 }, {
                'duration': 200,
                'callback': res
            });

            var arrow = _self._reels.stickSymbols[i].getArrow();
            arrow && arrow.fadeOut(200);
        }
    });
};

WinControl.prototype._removeStickSymbols = function() {
    for(var i = 0; i < this._reels.stickSymbols.length; i++) {
        this._reels.stickSymbols[i].destroyStick();
    }

    this._reels.stickSymbols.length = 0;
};

///**
// * @param {Array<AbstractSymbol>} resSymbols
// *  @param {AbstractSymbol} resSymbol
// * @returns {AbstractSymbol}
// */
//WinControl.getStickSymbol = function(resSymbols, resSymbol) {
//
//	for(var i = 0; i < )
//
//};

/**
 * @param {Array} positions
 * @returns {Array<AbstractSymbol>}
 */
WinControl.prototype._getResSymbols = function(positions) {
    return this._reels.getResSymbols(positions);
};

/**
 * @returns {Array<AbstractSymbol>}
 */
WinControl.prototype._getAllResSymbols = function() {
    return this._reels.getAllresSymbols();
};

/**
 * @param {number} reelX
 * @param {number} reelY
 * @param {AbstractSymbol} symbol
 */
WinControl.prototype._setResSymbol = function(reelX, reelY, symbol) {
    this._reels.getReel(reelX).resSymbols[reelY] = symbol;
};

/**
 * @param {Array<AbstractSymbol>} wildBgs
 * @returns {Promise}
 */
WinControl.prototype._showWildBgAnim = function(wildBgs) {

    return new Promise(function(res) {
        for(var i = 0; i < wildBgs.length; i++) {

            wildBgs[i].anims.loop("fire");

            MI.addTween().to(wildBgs[i], { 'alpha': 1 }, {
                'duration': 200,
                'callback': res
            });
        }
    });
};

/**
 * @param {Array<AbstractSymbol>} animsSymbols
 * @param {number} multi
 * @returns {Promise}
 */
WinControl.prototype._playWinlineAnim = function(animsSymbols, multi) {

    return new Promise(function(res) {

        var proms = [];

        for(var i = 0; i < animsSymbols.length; i++) {
            animsSymbols[i].setVisible(true);

            if(multi > 1) {
                proms.push(animsSymbols[i].playMulti());
            }
            proms.push(animsSymbols[i].playWinAnim());
        }

        Promise.all(proms).then(res);
    });
};

/**
 * @param {Array<AbstractSymbol>} symbols
 * @param {number} duration
 * @returns {Promise}
 */
WinControl.prototype._fadeOutSymbols = function(symbols, duration) {
    return new Promise(function(res) {
        for(var i = 0; i < symbols.length; i++) {
            (function(symbol) {

                MI.addTween().to(symbol, { 'alpha': 0 }, {
                    'duration': duration,
                    'callback': res
                    /*'callback': function() {
                        symbol.stopStandAnim();
                        symbol.clear();
                        symbol.setVisible(false);
                        symbol.setAlpha(1);
                        res();
                    }*/
                });

            } (symbols[i]));
        }
    });
};

/**
 * @param {AbstractSymbol} symbol
 * @returns {AbstractSymbol}
 */
WinControl.prototype._getResSymbol = function(symbol) {
    var reelX = symbol.reelPos['x'];
    var reelY = symbol.reelPos['y'];

    return this._reels.getReel(reelX).resSymbols[reelY];
};

WinControl.prototype._getIdenticSymbol = function(symbols, reelX, reelY) {

    for(var i = 0; i < symbols.length; i++) {
        if(symbols[i].getReelX() === reelX && symbols[i].getReelY() === reelY) {
            return symbols[i];
        }
    }
};

/**
 * @public
 * @returns {Promise}
 */
WinControl.prototype.end = function() {

    this._bigWinRunned = false;

    return new Promise(function(res) {

        this._reels.fadeOutBlackScreen().then(res);

    }.bind(this));
};

WinControl.prototype.wait = function(time) {
    return new Promise(function(res) {
        if(!time) { res(); return; }
        setTimeout(function() { res(); }, time);
    });
};